import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import { BASE_CLASS } from "./customize-experience";

interface CustomizeExperienceHeaderProps {
    heading: string;
    subheading?: string;
}

const CustomizeExperienceHeader = ({
    heading,
    subheading,
}: CustomizeExperienceHeaderProps) => {
    return (
        <header className={`${BASE_CLASS}__header`}>
            <Heading priority={HeadingPriority.Five}>{heading}</Heading>
            {subheading && <Paragraph>{subheading}</Paragraph>}
        </header>
    );
};

export default CustomizeExperienceHeader;
